var _style, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _g5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135 40",
    style: {
      enableBackground: "new 0 0 135 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A6A6;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2;stroke-miterlimit:10;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:url(#SVGID_3_);}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{opacity:0.2;enable-background:new    ;}\n\t.st8{opacity:0.12;enable-background:new    ;}\n\t.st9{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appstore"
  })), /*#__PURE__*/React.createElement("g", {
    id: "googleplay"
  }, /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130,40H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h125c2.8,0,5,2.2,5,5v30C135,37.8,132.8,40,130,40z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130,0.8c2.3,0,4.2,1.9,4.2,4.2v30c0,2.3-1.9,4.2-4.2,4.2H5c-2.3,0-4.2-1.9-4.2-4.2V5 c0-2.3,1.9-4.2,4.2-4.2L130,0.8 M130,0H5C2.2,0,0,2.2,0,5v30c0,2.8,2.2,5,5,5h125c2.8,0,5-2.2,5-5V5C135,2.2,132.8,0,130,0 L130,0z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.4,10.2c0,0.8-0.2,1.5-0.8,2c-0.6,0.6-1.3,0.9-2.2,0.9s-1.6-0.3-2.2-0.9s-0.9-1.4-0.9-2.2 c0-0.9,0.3-1.6,0.9-2.2s1.3-0.9,2.2-0.9c0.4,0,0.8,0.1,1.2,0.2s0.7,0.4,0.9,0.7L46,8.3c-0.4-0.5-0.9-0.7-1.6-0.7 c-0.6,0-1.2,0.2-1.6,0.7c-0.5,0.4-0.7,1-0.7,1.7s0.2,1.3,0.7,1.7s1,0.7,1.6,0.7c0.7,0,1.2-0.2,1.7-0.7c0.3-0.3,0.5-0.7,0.5-1.2 h-2.2V9.8h2.9C47.4,10,47.4,10.1,47.4,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52,7.7h-2.7v1.9h2.5v0.7h-2.5v1.9H52V13h-3.5V7H52V7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.3,13h-0.8V7.7h-1.7V7H57v0.7h-1.7V13L55.3,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.9,13V7h0.8v6H59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.1,13h-0.8V7.7h-1.7V7h4.1v0.7H64L64.1,13L64.1,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.6,12.2c-0.6,0.6-1.3,0.9-2.2,0.9s-1.6-0.3-2.2-0.9s-0.9-1.4-0.9-2.2s0.3-1.6,0.9-2.2s1.3-0.9,2.2-0.9 c0.9,0,1.6,0.3,2.2,0.9s0.9,1.4,0.9,2.2C74.5,10.9,74.2,11.6,73.6,12.2z M69.8,11.7c0.4,0.5,1,0.7,1.6,0.7s1.2-0.2,1.6-0.7 s0.7-1,0.7-1.7S73.5,8.7,73,8.3c-0.4-0.5-1-0.7-1.6-0.7s-1.2,0.2-1.6,0.7s-0.7,1-0.7,1.7S69.3,11.3,69.8,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.6,13V7h0.9l2.9,4.7l0,0v-1.2V7h0.8v6h-0.8l-3.1-4.9l0,0v1.2V13H75.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.1,21.8c-2.3,0-4.3,1.8-4.3,4.2c0,2.5,1.9,4.2,4.3,4.2s4.3-1.8,4.3-4.2C72.4,23.5,70.5,21.8,68.1,21.8z  M68.1,28.6c-1.3,0-2.4-1.1-2.4-2.6s1.1-2.6,2.4-2.6s2.4,1,2.4,2.6C70.5,27.5,69.4,28.6,68.1,28.6z M58.8,21.8 c-2.3,0-4.3,1.8-4.3,4.2c0,2.5,1.9,4.2,4.3,4.2s4.3-1.8,4.3-4.2C63.1,23.5,61.2,21.8,58.8,21.8z M58.8,28.6 c-1.3,0-2.4-1.1-2.4-2.6s1.1-2.6,2.4-2.6s2.4,1,2.4,2.6C61.2,27.5,60.1,28.6,58.8,28.6z M47.7,23.1v1.8H52c-0.1,1-0.5,1.8-1,2.3 c-0.6,0.6-1.6,1.3-3.3,1.3c-2.7,0-4.7-2.1-4.7-4.8s2.1-4.8,4.7-4.8c1.4,0,2.5,0.6,3.2,1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8 c-3.6,0-6.7,3-6.7,6.6s3.1,6.6,6.7,6.6c2,0,3.5-0.6,4.6-1.8c1.2-1.2,1.6-2.9,1.6-4.2c0-0.4,0-0.8-0.1-1.1L47.7,23.1L47.7,23.1z  M93.1,24.5c-0.3-1-1.4-2.7-3.6-2.7s-4,1.7-4,4.2c0,2.4,1.8,4.2,4.2,4.2c1.9,0,3.1-1.2,3.5-1.9l-1.4-1c-0.5,0.7-1.1,1.2-2.1,1.2 s-1.6-0.4-2.1-1.3l5.7-2.3L93.1,24.5z M87.2,25.9c-0.1-1.6,1.3-2.5,2.2-2.5c0.7,0,1.4,0.4,1.6,0.9L87.2,25.9z M82.6,30h1.9V17.5 h-1.9V30z M79.6,22.7L79.6,22.7c-0.5-0.5-1.3-1-2.3-1c-2.1,0-4.1,1.9-4.1,4.3s1.9,4.2,4.1,4.2c1,0,1.8-0.5,2.2-1h0.1v0.6 c0,1.6-0.9,2.5-2.3,2.5c-1.1,0-1.8-0.8-2.1-1.5l-1.6,0.7c0.5,1.1,1.7,2.5,3.8,2.5c2.2,0,4-1.3,4-4.4V22h-1.8L79.6,22.7L79.6,22.7z  M77.4,28.6c-1.3,0-2.4-1.1-2.4-2.6s1.1-2.6,2.4-2.6s2.3,1.1,2.3,2.6C79.7,27.5,78.7,28.6,77.4,28.6z M101.8,17.5h-4.5V30h1.9 v-4.7h2.6c2.1,0,4.1-1.5,4.1-3.9S103.9,17.5,101.8,17.5z M101.8,23.5h-2.7v-4.3h2.7c1.4,0,2.2,1.2,2.2,2.1S103.2,23.5,101.8,23.5z  M113.4,21.7c-1.3,0-2.8,0.6-3.3,1.9l1.7,0.7c0.3-0.7,1-0.9,1.7-0.9c1,0,1.9,0.6,2,1.6v0.1c-0.3-0.2-1.1-0.5-1.9-0.5 c-1.8,0-3.6,1-3.6,2.8c0,1.7,1.5,2.8,3.1,2.8c1.2,0,1.9-0.6,2.4-1.2h0.1v1h1.8v-4.8C117.2,23,115.5,21.7,113.4,21.7z M113.2,28.6 c-0.6,0-1.5-0.3-1.5-1.1c0-1,1.1-1.3,2-1.3c0.8,0,1.2,0.2,1.7,0.4C115.2,27.8,114.2,28.6,113.2,28.6z M123.7,22l-2.1,5.4h-0.1 l-2.2-5.4h-2l3.3,7.6l-1.9,4.2h1.9l5.1-11.8H123.7z M106.9,30h1.9V17.5h-1.9V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.795,
    y1: -608.4847,
    x2: 5.0126,
    y2: -625.267,
    gradientTransform: "matrix(1 0 0 -1 0 -599.7796)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.4,7.5C10.1,7.9,10,8.3,10,8.9V31c0,0.6,0.2,1.1,0.5,1.4l0.1,0.1L23,20.1V20v-0.1L10.4,7.5L10.4,7.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.8344,
    y1: -619.8296,
    x2: 9.6375,
    y2: -619.8296,
    gradientTransform: "matrix(1 0 0 -1 0 -599.7796)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27,24.3l-4.1-4.1V20v-0.1l4.1-4.1h0.1l4.9,2.8c1.4,0.8,1.4,2.1,0,2.9L27,24.3L27,24.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.8154,
    y1: -622.0641,
    x2: 2.0571,
    y2: -644.8224,
    gradientTransform: "matrix(1 0 0 -1 0 -599.7796)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.1,24.2L22.9,20L10.4,32.5c0.5,0.5,1.2,0.5,2.1,0.1L27.1,24.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.2867,
    y1: -599.9666,
    x2: 17.4493,
    y2: -610.129,
    gradientTransform: "matrix(1 0 0 -1 0 -599.7796)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.1,15.8L12.5,7.5c-0.9-0.5-1.6-0.5-2.1,0L22.9,20L27.1,15.8z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27,24.1l-14.5,8.2c-0.8,0.5-1.5,0.4-2,0l0,0l-0.1,0.1l0,0l0.1,0.1l0,0c0.5,0.4,1.2,0.5,2,0L27,24.1 L27,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.4,32.3C10.1,32,10,31.5,10,30.9v0.2c0,0.6,0.2,1.1,0.5,1.4v-0.2H10.4z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M32,21.3l-5,2.8l0.1,0.1l4.9-2.8c0.7-0.4,1-0.9,1-1.4l0,0C33,20.5,32.7,20.9,32,21.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.5,7.6L32,18.7c0.6,0.4,1,0.8,1,1.3l0,0c0-0.5-0.3-1-1-1.4L12.5,7.6C11.1,6.7,10,7.4,10,8.9V9 C10,7.5,11.1,6.8,12.5,7.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGooglePlay);
export default __webpack_public_path__ + "static/media/btn_GooglePlay.ed79988fb6677300094b1493f5411778.svg";
export { ForwardRef as ReactComponent };